<template>
    <Layout :content-class="'content--narrow'" style="padding-bottom: 60px;">
        <div
            class="books-list__search search-input"
            style="max-width: 560px; margin: 0 auto; margin-bottom: 20px;"
        >
            <input
                v-model="search"
                type="text"
                autofocus
                class="search-input__input"
                placeholder="Введите слово, слог"
                @keyup="onSearchInput"
            />
        </div>
        <table class="phoneme-table" style="max-width: 560px; margin: 0 auto;">
            <thead class="phoneme-table__head">
                <th class="phoneme-table__head-cell">Слово</th>
                <th class="phoneme-table__head-cell">Фонема</th>
                <th class="phoneme-table__head-cell">Статус</th>
                <th class="phoneme-table__head-cell"></th>
            </thead>
            <TransitionGroup v-if="phonemes.length" tag="tbody" name="fade">
                <tr v-for="ph in phonemes" :key="ph.id" class="phoneme-table__row">
                    <td class="phoneme-table__cell">{{ ph.key }}</td>
                    <td class="phoneme-table__cell">
                        <div class="phoneme-table__withplayer">
                            <PlayButton @click.prevent="getSample(ph.id)" />
                            {{ ph.value }}
                        </div>
                    </td>
                    <td class="phoneme-table__cell">
                        <span>
                            {{ ph.is_active ? 'Активна' : 'Неактивна' }}
                        </span>
                    </td>
                    <td class="phoneme-table__cell" style="text-align: right;">
                        <button
                            type="button"
                            class="button button--blank phoneme-table__bin"
                            style="margin-right: 10px;"
                            @click="changeStatus(ph)"
                        >
                            {{ ph.is_active ? 'Деактивировать' : 'Активировать' }}
                        </button>
                        <button
                            class="button button--blank phoneme-table__bin"
                            type="button"
                            @click="deletePhoneme(ph.id)"
                        >
                            <svg
                                height="15"
                                width="15"
                                viewBox="-40 0 427 427.001"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M232.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0M114.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0"
                                />
                                <path
                                    d="M28.398 127.121V373.5c0 14.563 5.34 28.238 14.668 38.05A49.246 49.246 0 0078.796 427H268a49.233 49.233 0 0035.73-15.45c9.329-9.812 14.668-23.487 14.668-38.05V127.121c18.543-4.922 30.559-22.836 28.079-41.863-2.485-19.024-18.692-33.254-37.88-33.258h-51.199V39.5a39.289 39.289 0 00-11.539-28.031A39.288 39.288 0 00217.797 0H129a39.288 39.288 0 00-28.063 11.469A39.289 39.289 0 0089.398 39.5V52H38.2C19.012 52.004 2.805 66.234.32 85.258c-2.48 19.027 9.535 36.941 28.078 41.863zM268 407H78.797c-17.098 0-30.399-14.688-30.399-33.5V128h250v245.5c0 18.813-13.3 33.5-30.398 33.5zM109.398 39.5a19.25 19.25 0 015.676-13.895A19.26 19.26 0 01129 20h88.797a19.26 19.26 0 0113.926 5.605 19.244 19.244 0 015.675 13.895V52h-128zM38.2 72h270.399c9.941 0 18 8.059 18 18s-8.059 18-18 18H38.199c-9.941 0-18-8.059-18-18s8.059-18 18-18zm0 0"
                                />
                                <path
                                    d="M173.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0"
                                />
                            </svg>
                            Удалить
                        </button>
                    </td>
                </tr>
            </TransitionGroup>
            <tbody v-if="!phonemes.length">
                <tr clas="phoneme-table__row">
                    <td class="phoneme-table__cell" colspan="3">
                        {{ $t('misc.notfound') }}
                    </td>
                </tr>
            </tbody>
            <tbody v-if="loading">
                <tr clas="phoneme-table__row">
                    <td class="phoneme-table__cell" colspan="3">
                        <Spinner v-if="loading" class="spinner--gray" />
                    </td>
                </tr>
            </tbody>
        </table>
        <button
            v-if="canLoadMore"
            class="button button--centered button--medium"
            type="button"
            style="margin-top: 30px;"
            :disabled="loading"
            @click="loadMore"
        >
            Загрузить ещё
        </button>
        <audio ref="audio" class="visually-hidden" :src="sample" controls></audio>
    </Layout>
</template>

<script>
// @TODO move this to manage later
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import { PlayButton } from '@speechki-frontend/shared/ui/Player';

import { mapActions, mapGetters } from 'vuex';

import {
    adminFetchPhonemes,
    adminFetchSample,
    adminDeletePhoneme,
    adminChangeActivity
} from '@speechki-frontend/core/editor/api/phonemes';

export default {
    name: 'Phonemes',
    components: {
        Layout,
        PlayButton
    },
    data() {
        return {
            phonemes: [],
            count: 0,
            search: '',
            pageSize: 20,
            page: 1,
            sample: null,
            timeout: null,
            activeId: null,
            loading: false
        };
    },
    computed: {
        ...mapGetters(['isStaff', 'isAdmin']),
        canLoadMore() {
            return this.count > this.page * this.pageSize;
        }
    },
    watch: {
        page() {
            this.fetchPhonemes();
        },
        search() {
            this.page = 1;
        }
    },
    created() {
        if (!this.isStaff && !this.isAdmin) {
            this.$router.push('/');
        }
        this.fetchPhonemes();
    },
    methods: {
        ...mapActions(['pushToast']),
        async fetchPhonemes() {
            this.loading = true;

            const params = {
                page_size: this.pageSize,
                page: this.page,
                ordering: '-id'
            };

            if (this.search) {
                params.search = this.search;
            }

            const { results, count } = await adminFetchPhonemes(params);

            if (this.page > 1) {
                this.phonemes = [...this.phonemes, ...results];
            } else {
                this.phonemes = results;
            }
            this.count = count;

            this.loading = false;
        },
        async getSample(id) {
            this.activeId = id;
            try {
                const response = await adminFetchSample(id, { speaker__slug: 'speaker_1' });

                if (response.sample) {
                    this.sample = response.sample;

                    this.$refs.audio.oncanplaythrough = () => {
                        if (this.activeId !== id) return;
                        this.$refs.audio.play();
                    };
                    this.$refs.audio.onended = () => {
                        if (this.activeId !== id) return;
                        this.sample = null;
                    };
                }
            } catch (error) {
                this.loading = false;
                this.pushToast({
                    id: Date.now(),
                    title: '',
                    type: 'error',
                    text: error.detail ? error.detail.join(', ') : 'Error occured'
                });
            }
        },
        loadMore() {
            this.page = this.page + 1;
        },
        onSearchInput() {
            clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.fetchPhonemes();
            }, 250);
        },
        async deletePhoneme(id) {
            try {
                this.loading = true;
                await adminDeletePhoneme(id);
                this.phonemes = this.phonemes.filter(ph => ph.id !== id);
                this.count = this.count - 1;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.pushToast({
                    id: Date.now(),
                    title: '',
                    type: 'error',
                    text: error.detail ? error.detail.join(', ') : 'Error occured'
                });
            }
        },
        async changeStatus({ id, is_active }) {
            try {
                this.loading = true;
                await adminChangeActivity(id, !is_active);
                let phoneme = this.phonemes.find(ph => ph.id === id);
                phoneme.is_active = !is_active;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.pushToast({
                    id: Date.now(),
                    title: '',
                    type: 'error',
                    text: error.detail ? error.detail.join(', ') : 'Error occured'
                });
            }
        }
    }
};
</script>
